import React, { useEffect, useState } from 'react';
import './index.css';
import clsx from 'classnames';

const System = () => {
  const [systemType, setSystemType] = useState('人员管理');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // 获取当前可是窗口宽度
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onMouseEnter = (v) => {
    setSystemType(v.name);
  };

  const systemList = [
    {
      name: '人员管理',
      img: '/img/renyuan.png',
      icon: '/img/renyuanIcon.png',
      textList: ['对员工进行精确管理', '管理客户相关信息'],
    },
    {
      name: '资料管理',
      img: '/img/ziliao.png',
      icon: '/img/ziliaoIcon.png',
      textList: ['标准文件', '体系文件'],
    },
    {
      name: '检测管理',
      img: '/img/jiance.png',
      icon: '/img/jianceIcon.png',
      textList: ['委托全流程管理', '检测数据存储'],
    },
    {
      name: '报告管理',
      img: '/img/baogao.png',
      icon: '/img/baogaoIcon.png',
      textList: ['编制/审核/批准', '报告预览及发放'],
    },
    {
      name: '财务管理',
      img: '/img/caiwu.png',
      icon: '/img/caiwuIcon.png',
      textList: ['检测费用', '开票到账'],
    },
    {
      name: '合同管理',
      img: '/img/hetong.png',
      icon: '/img/hetongIcon.png',
      textList: ['检测合同', '采购合同'],
    },
    {
      name: '权限管理',
      img: '/img/quanxian.png',
      icon: '/img/quanxianIcon.png',
      textList: ['职级层次划分', '权限细化配置'],
    },
    {
      name: '模版管理',
      img: '/img/muban.png',
      icon: '/img/mubanIcon.png',
      textList: ['委托单模版', '原始记录单/检测报告模版'],
    },
  ];

  return (
    <div className={clsx('intelligence-system')}>
      <div className={clsx('intelligence-system-title')}>系统功能</div>
      <div className={clsx('intelligence-system-text')}>
        全方位覆盖实际工作需求
      </div>
      <div className={clsx('intelligence-system-content')}>
        {systemList.map((v, index) => (
          <div
            key={index}
            className={clsx('intelligence-system-content-item', {
              itemActive: windowWidth > 1440 ? systemType === v.name : true,
            })}
            style={{
              backgroundImage: `url(${systemType === v.name || windowWidth <= 1440 ? v.img : '/img/systemBg.png'})`,
            }}
            onMouseEnter={() => onMouseEnter(v)}
            onMouseLeave={() => onMouseEnter(v)}
          >
            {systemType === v.name || windowWidth <= 1440 ? (
              <div className={clsx('intelligence-system-content-item-hover')}>
                <div
                  className={clsx(
                    'intelligence-system-content-item-hover-title',
                  )}
                >
                  {v.name}
                </div>
                {v.textList.map((item, index) => (
                  <div
                    key={index}
                    className={clsx(
                      'intelligence-system-content-item-hover-text',
                    )}
                  >
                    {item}
                  </div>
                ))}
              </div>
            ) : (
              <>
                <img src={v.icon} alt='' width={50} height={50} />
                <div className={clsx('intelligence-system-content-item-title')}>
                  {v.name}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default System;
